module.exports = __webpack_public_path__ + "img/member01.be7e9da4.png";